import { useNavigate } from 'react-router';
import { OrganizationApi, ToastStateHandler } from '../../../api';
import { CreateHolidayDto } from '../../../commonTypes/organization.types';
import { useContainer } from '../../useContainer';
import { useTranslation } from '../../useTranslation';
import { AppError, ErrorCodes, getUserMessage, isErrorCode } from '../../../api/utils/ErrorHandler';

const useHttpPostHoliday = () => {
    const { t } = useTranslation('newNotifications');
    const organizationApi: OrganizationApi = useContainer(OrganizationApi);
    const toastHandler = useContainer(ToastStateHandler);
    const navigate = useNavigate();

    const exec = (body: CreateHolidayDto) => {
        const { exec, abort } = organizationApi.postHoliday({
            body,
            onSuccess: _ => {
                toastHandler.push('success', t('holiday.createHolidayTitle'), t('holiday.createHolidayMessage_Success'));
                navigate(`/holidays/${body.date.getFullYear().toString()}`);
            },
            onError: (error: AppError | string) => {
                if (isErrorCode(error, ErrorCodes.SUBSCRIPTION_FEATURE_UNAVAILABLE) || isErrorCode(error, ErrorCodes.SUBSCRIPTION_UPGRADE_REQUIRED)) {
                    const message = typeof error === 'object' ? getUserMessage(error) : error;
                    toastHandler.push('error', t('holiday.createHolidayTitle'), message);
                } else {
                    const message =
                        typeof error === 'object'
                            ? getUserMessage(error, t('holiday.createHolidayMessage_Failed'))
                            : t('holiday.createHolidayMessage_Failed');
                    toastHandler.push('error', t('holiday.createHolidayTitle'), message);
                }
            },
        });
        exec();
        return abort;
    };

    return { exec };
};

export default useHttpPostHoliday;
